import React, { useCallback, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import PageHeader from "@/components/PageHeader";
import ScheduleTabs, { useTabParam } from "@/components/ScheduleTabs";
import { useFeatureFlags } from "@/lib/featureFlags";
import api from "@/lib/api";
import CoachMembers from "./Members";
import CoachParents from "./Parents";
import CoachGroups from "./Groups";
import CoachBios from "./Bios";

// Old standalone URLs (/coach/requests, /coach/parents, /coach/groups, /coach/bios) land on their tab.
export function MembersTabRedirect({ tab }) {
  const { search } = useLocation();
  return <Navigate to={`/coach/members?tab=${tab}${search ? `&${search.slice(1)}` : ""}`} replace />;
}

function usePendingCounts() {
  const [counts, setCounts] = useState({ requests: 0, parents: 0 });
  const load = useCallback(() => {
    api.get("/coach/assignment-requests").then(({ data }) => setCounts((c) => ({ ...c, requests: (data.items || []).filter((i) => i.assignment_status === "pending").length }))).catch(() => {});
    api.get("/coach/parent-requests").then(({ data }) => setCounts((c) => ({ ...c, parents: data.pending_count || 0 }))).catch(() => {});
  }, []);
  useEffect(() => {
    load();
    window.addEventListener("rpg:badges-refresh", load);
    return () => window.removeEventListener("rpg:badges-refresh", load);
  }, [load]);
  return counts;
}

export default function TeamMembersHub() {
  const { parent_account: parentsOn, bios: biosOn } = useFeatureFlags();
  const counts = usePendingCounts();
  const tabs = [{ key: "roster", label: "Roster", badge: counts.requests },
    parentsOn && { key: "parents", label: "Parents", badge: counts.parents }, { key: "groups", label: "Groups" },
    biosOn && { key: "bios", label: "Bio List" }].filter(Boolean);
  const [tab, setTab] = useTabParam(tabs.map((t) => t.key));
  return (
    <div data-testid="coach-team-members-page">
      <PageHeader title="Team Members" />
      <ScheduleTabs tabs={tabs} value={tab} onChange={setTab} testId="members" />
      {tab === "roster" && <CoachMembers />}
      {tab === "parents" && <CoachParents />}
      {tab === "groups" && <CoachGroups />}
      {tab === "bios" && <CoachBios />}
    </div>
  );
}
